export default "__VITE_ASSET__BaAKP1EP__"